import { inject, injectable } from 'inversify';
import { TYPES } from '../ioc/types';
import type { OfflineDB } from './OfflineDB';

@injectable()
export class OfflineUtilsService {
  private readonly _offlineDb: OfflineDB;

  public constructor(@inject(TYPES.OfflineDB) offlineDb: OfflineDB) {
    this._offlineDb = offlineDb;
  }

  public getOfflineUrlForBlob(packageId: string, descriptor: string): string {
    return `offline/${packageId}/blob/${descriptor}`;
  }

  public async isCaseAvailableOffline(caseId: string, packageId: string): Promise<boolean> {
    const caseData = await this._offlineDb.schema.cases.get(caseId);
    if (!caseData) {
      return false;
    }

    const offlinePackages = caseData.savedPackages;

    return offlinePackages.includes(packageId);
  }
}
